import { useTranslation } from "next-i18next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import Head from "next/head";
import Link from "next/link";
import { FiEdit, FiPlus, FiTrash2 } from "react-icons/fi";
import { ConfirmationOverlay } from "../../../../components/common/ConfirmationOverlay";
import { Nav } from "../../../../components/common/Nav";
import { QueryWrapper } from "../../../../components/common/QueryWrapper";
import { useUrl } from "../../../../hooks/common/useUrl";
import { useDeleteVenue, useGetVenues } from "../../../../hooks/venue";
import { Venue } from "../../../../models/Venue";
import { BackendErrorMessage } from "../../../../components/common/ErrorMessage";
import { NoItems } from "../../../../components/common/NoItems";

export async function getServerSideProps({ locale }: { locale: string }) {
  return {
    props: {
      ...(await serverSideTranslations(locale)),
    },
  };
}

export function AddVenuesView() {
  const { customUrl } = useUrl();
  const { t } = useTranslation();
  return (
    <Link href={customUrl("/venues/add")} className="btn mb-8">
      <FiPlus className="mr-2" /> {t("Add_Venue")}
    </Link>
  );
}

export default function VenuesPage() {
  const { t } = useTranslation();
  const { data: venues, ...venuesResult } = useGetVenues();
  return (
    <>
      <Head>
        <title>TTBL Adminsystem | Spielorte</title>
      </Head>
      <div>
        <Nav />
        <div className="container">
          <div className="flex justify-end"></div>
          <div className="rounded-b-lg  py-8 mb-10">
            <QueryWrapper useQueryResult={[venuesResult]}>
              {venues && venues.length > 0 && (
                <table>
                  <tbody>
                    <tr className="table-header row_item">
                      <th>{t("Label_Hall_Name")}</th>
                      <th>{t("Label_Adress")}</th>
                      <th>{t("Label_Place")}</th>
                      <th className="text-right">{t("Label_Options")}</th>
                    </tr>
                    {venues.map((venue) => (
                      <VenueCard key={venue.id} venue={venue} />
                    ))}
                  </tbody>
                </table>
              )}
              {venues?.length === 0 && <NoItems />}
            </QueryWrapper>
          </div>
        </div>
      </div>
    </>
  );
}

interface VenueCardProps {
  venue: Venue;
}
export function VenueCard({ venue }: VenueCardProps) {
  const {
    mutate: deleteVenue,
    error: deleteError,
    isLoading: isVenueLoading,
  } = useDeleteVenue({
    venueId: venue.id,
  });
  const { customUrl } = useUrl();
  const { t } = useTranslation();
  return (
    <tr className="row_item">
      <td>
        <Link
          href={customUrl(`/venues/edit/${venue.id}`)}
          className="flex w-full"
        >
          {venue.name}
        </Link>
      </td>
      <td>
        <Link
          href={customUrl(`/venues/edit/${venue.id}`)}
          className="flex w-full"
        >
          {venue.adress}
        </Link>
      </td>
      <td>
        <Link
          href={customUrl(`/venues/edit/${venue.id}`)}
          className="flex w-full"
        >
          {venue.place}
        </Link>
      </td>
      <td className="">
        <div className="flex justify-end gap-2">
          <Link href={customUrl(`/venues/edit/${venue.id}`)}>
            <FiEdit />
          </Link>
          <ConfirmationOverlay
            isSubmitting={isVenueLoading}
            onClick={() => deleteVenue()}
            confirmationMessage={t("Confirmation_Delete") as string}
          >
            <div>
              <FiTrash2 />
            </div>
          </ConfirmationOverlay>
        </div>
      </td>
      <BackendErrorMessage error={deleteError} />
    </tr>
  );
}
